export const ViewContentTracking = (data) => {
  const {
    product_variant_name,
    product_name,
    product_variant_sku,
    product_sku,
    product,
    category,
    prices
  } = data;
  window.fbq('track', 'ViewContent', {
    content_name: product_variant_name ? product_variant_name : product_name,
    content_category: product ? product.category.category_name : category.category_name,
    content_ids: product_variant_sku ? product_variant_sku : product_sku,
    content_type: 'product',
    value: prices.promo_price ? prices.promo_price : prices.price,
    currency: 'PLN'
   });
}

export const AddToCartTracking = (product, count) => {
  const {
    product_variant_name,
    product_name,
    product_variant_sku,
    product_sku,
    prices
  } = product;
  window.fbq("track", "AddToCart", {
    content_name: product_variant_name ? product_variant_name : product_name,
    content_ids: [product_variant_sku ? product_variant_sku : product_sku],
    content_type: "product",
    value: (prices.promo_price * count).toFixed(2),
    currency: "PLN",
  });
};

export const PurchaseTracking = (total) => {
  window.fbq('track', 'Purchase', {currency: "PLN", value: total.toFixed(2)});
}